module.exports = __webpack_public_path__ + "img/stamp_landing_bg.defe154d.png";